(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gramofonika-cart"]) return;
  try {
    
  document.querySelectorAll('[data-gm-cart]').forEach((form) => {
    const limit = parseInt(form.dataset.gmMax, 10) || 3;

    const clamp = (field) => {
      const value = Math.min(limit, Math.max(0, parseInt(field.value, 10) || 0));
      field.value = value;
      const plus = field.parentElement.querySelector('[data-gm-step="1"]');
      if (plus) plus.disabled = value >= limit;
      return value;
    };

    // «−» и «+» местят числото и подават формата.
    form.addEventListener('click', (event) => {
      const button = event.target.closest('[data-gm-step]');
      if (!button || button.disabled) return;

      const field = button.parentElement.querySelector('.gm-stepper__input');
      if (!field) return;

      field.value = (parseInt(field.value, 10) || 0) + parseInt(button.dataset.gmStep, 10);
      clamp(field);
      form.requestSubmit();
    });

    form.addEventListener('change', (event) => {
      if (!event.target.matches('.gm-stepper__input')) return;
      clamp(event.target);
      form.requestSubmit();
    });

    // «Към плащане» не разчита на подаването на формата: количествата се записват
    // през /cart/update.js и после се отива на касата.
    form.addEventListener('submit', async (event) => {
      const updates = [...form.querySelectorAll('.gm-stepper__input')].map((field) => clamp(field));

      if (!event.submitter || event.submitter.name !== 'checkout') return;

      event.preventDefault();
      event.submitter.disabled = true;

      try {
        await fetch(form.dataset.gmUpdate || '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
      } catch (error) {
        // Ако записът се провали, касата пак ще покаже кошницата такава, каквато е.
      }

      window.location.href = '/checkout';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gramofonika-catalog-order"] && !Shopify.designMode) return;
  try {
    
  // Търсенето в каталога и заявката са свързани в едно: намереното издание не се
  // праща само за себе си, а попълва формата вдясно. Така има един път на
  // доставяне — писмото до магазина, — вместо втора точка, която да поддържаме.
  document.querySelectorAll('[data-gm-catalog]').forEach((root) => {
    const words = root.dataset;
    const form = root.querySelector('[data-gm-catalog-form]');
    const input = root.querySelector('[data-gm-catalog-input]');
    const box = root.querySelector('[data-gm-catalog-results]');
    const list = root.querySelector('[data-gm-catalog-list]');
    const count = root.querySelector('[data-gm-catalog-count]');
    const ask = root.querySelector('.gm-ask');
    const box_ask = root.querySelector('[data-gm-ask]');
    const what = root.querySelector('[data-gm-catalog-what]');

    const root_url = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* Редът «Заявявате» показва избраното издание и се маха с бутон. Скритите
       полета го придружават: те са за ERP-то, редът — за човека. */
    const chosen = root.querySelector('[data-gm-catalog-chosen]');
    const chosenTitle = root.querySelector('[data-gm-catalog-chosen-title]');
    const chosenMeta = root.querySelector('[data-gm-catalog-chosen-meta]');

    const показва = ({ title, meta }) => {
      if (!chosen) return;
      if (chosenTitle) chosenTitle.textContent = title || '';
      if (chosenMeta) {
        chosenMeta.textContent = meta || '';
        chosenMeta.hidden = !meta;
      }
      chosen.hidden = !title;
    };

    root.querySelector('[data-gm-catalog-chosen-drop]')?.addEventListener('click', () => {
      показва({ title: '', meta: '' });
      const holder = root.querySelector('[data-gm-catalog-handle]');
      const ref = root.querySelector('[data-gm-catalog-ref]');
      if (holder) holder.value = '';
      if (ref) ref.value = '';
      if (what) what.value = '';
      what?.focus();
    });

    /* Страницата на плочата и мини страницата от каталога пращат в адреса кой
       е изборът: изпълнител и заглавие (за човека), handle или ref (за
       ERP-то). Дошлият оттам не бива да преписва това, което току-що е чел.
       Блокът стои СЛЕД «показва» — ползва я, а тя е const. */
    const fromUrl = new URLSearchParams(window.location.search);
    if (fromUrl.has('artist') || fromUrl.has('title') || fromUrl.has('handle') || fromUrl.has('ref')) {
      const said = [fromUrl.get('artist'), fromUrl.get('title')].filter(Boolean).join(' — ');
      if (what && said) what.value = said;
      const holder = root.querySelector('[data-gm-catalog-handle]');
      if (holder && fromUrl.get('handle')) holder.value = fromUrl.get('handle');
      const refField = root.querySelector('[data-gm-catalog-ref]');
      if (refField && fromUrl.get('ref')) refField.value = fromUrl.get('ref');
      if (said && (fromUrl.get('ref') || fromUrl.get('handle'))) {
        показва({ title: said, meta: fromUrl.get('ref') || '' });
      }
      if (box_ask) box_ask.open = true;
      root.querySelector('[name="contact[email]"]')?.focus({ preventScroll: true });
    }

    /* Разгъването е на `details`, не на скрипт — тук само се пълни свободното
       поле при първо отваряне. Каквото човек е търсил, вече го е написал веднъж;
       да го пише пак е излишна работа. */
    const openAsk = () => {
      if (!box_ask) return;
      box_ask.open = true;
    };

    /* Разгънат, панелът се затваря САМО от «Затвори». Иначе клик по заглавието
       или по празното до него го прибира, докато човек пише — `summary` е
       кликаем целият по рождение. Без скрипт остава старото поведение: цялата
       лента затваря. */
    box_ask?.querySelector('.gm-ask__summary')?.addEventListener('click', (event) => {
      if (!box_ask.open) return;
      if (event.target.closest('.gm-ask__close')) return;
      event.preventDefault();
    });

    box_ask?.addEventListener('toggle', () => {
      if (!box_ask.open || !what || what.value.trim()) return;
      const typed = input ? input.value.trim() : '';
      if (typed) what.value = typed;
    });

    /* Подаването не напуска страницата.

       Обикновената форма на Shopify работи, но презарежда, връща човека в
       началото на екрана и оставя потвърждението някъде под хедъра. Натиснал
       бутон и видял същата форма, човек не знае дали е станало.

       Затова заявката минава през fetch, а отговорът се чете за същото, което би
       се видяло след презареждане. Обърка ли се нещо по този път, формата се
       подава по стария начин — по-добре презареждане, отколкото изгубена заявка. */
    const fillBody = () => {
      const body = root.querySelector('[data-gm-catalog-body]');
      if (!body) return;

      const parts = [];
      for (const node of ask.querySelectorAll('textarea[name^="contact["], input[name^="contact["]')) {
        if (node.type === 'hidden') continue;
        if (node.name === 'contact[email]' || node.name === 'contact[id]') continue;
        if (!node.value.trim()) continue;
        const label = node.name.replace('contact[', '').replace(']', '');
        parts.push(label + ': ' + node.value.trim());
      }
      const ref = root.querySelector('[data-gm-catalog-ref]');
      if (ref && ref.value) parts.push('Издание от каталога: ' + ref.value);
      const holder = root.querySelector('[data-gm-catalog-handle]');
      if (holder && holder.value) parts.push('Адрес на плочата: ' + holder.value);
      body.value = parts.join('\n');
    };

    const done = root.querySelector('[data-gm-catalog-done]');
    const problem = root.querySelector('[data-gm-catalog-error]');
    const submit = root.querySelector('[data-gm-catalog-submit]');

    ask?.addEventListener('submit', async (event) => {
      if (!submit || ask.dataset.gmBusy === 'true') return;

      event.preventDefault();
      fillBody();

      ask.dataset.gmBusy = 'true';
      submit.disabled = true;
      submit.textContent = submit.dataset.gmLabelBusy;
      if (problem) problem.hidden = true;

      let settled = false;
      /* Заявката отива в ERP-то, не по пощата: там я вижда собственикът и там се
         връзва за изданието. Формата остава форма за връзка на Shopify, за да има
         КЪДЕ да падне, ако ERP-то мълчи — писмото стига до магазина и заявката не
         се губи. */
      try {
        const holder = root.querySelector('[data-gm-catalog-handle]');
        const mail = root.querySelector('[name="contact[email]"]');
        const body = root.querySelector('[data-gm-catalog-body]');

        const payload = { email: mail ? mail.value : '', note: body ? body.value : '' };
        if (holder && holder.value) payload.handle = holder.value;

        const response = await fetch(root_url() + 'apps/gramofonika/catalog-request', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await response.json().catch(() => null);

        if (response.status === 400 && data && data.detail) {
          if (problem) {
            problem.textContent = data.detail;
            problem.hidden = false;
          }
          if (mail) mail.focus({ preventScroll: true });
          settled = true;
          return;
        }

        if (response.ok && data && data.success) {
          // Няма какво повече да се прави тук, значи няма какво да стои.
          for (const node of ask.querySelectorAll('.gm-field, .gm-catalog__pair, button, .gm-catalog__fine')) {
            node.hidden = true;
          }
          if (done) {
            const said = done.querySelector('[data-gm-catalog-said]');
            if (said && data.already) said.textContent = words.gmWordAlready;
            done.hidden = false;
            done.setAttribute('tabindex', '-1');
            done.focus({ preventScroll: true });
          }
          settled = true;
          return;
        }

        throw new Error('неразпознат отговор');
      } catch (error) {
        // По-добре презареждане, отколкото изгубена заявка.
        ask.dataset.gmBusy = 'false';
        ask.submit();
        return;
      } finally {
        if (!settled) {
          ask.dataset.gmBusy = 'false';
        } else {
          submit.disabled = false;
          submit.textContent = submit.dataset.gmLabelIdle;
          ask.dataset.gmBusy = 'false';
        }
      }
    });

    if (!form) return;

    const line = (text, cls) => {
      const node = document.createElement('span');
      node.className = cls;
      node.textContent = text;
      return node;
    };

    const say = (text) => {
      list.replaceChildren(line(text, 'gm-catalog__note'));
      count.textContent = '';
      /* Съобщение вместо списък: и страниците, и постоянната височина се махат —
         инак «търся…» стои в кутия, висока колкото шест реда. */
      box.classList.remove('gm-catalog__results--paged');
      const bar = root.querySelector('[data-gm-catalog-pager]');
      const note = root.querySelector('[data-gm-catalog-more]');
      if (bar) bar.hidden = true;
      if (note) note.hidden = true;
      box.hidden = false;
    };

    /* Един ред от каталога. Текстът във всяка клетка е отрязан с многоточие, а
       не пренесен — така редът е с ПОСТОЯННА височина и списъкът не мени ръста
       си според това какво е върнал каталогът. */
    const drawRow = (item) => {
      const row = document.createElement('div');
      row.className = 'gm-catalog__hit';

      const cover = document.createElement('span');
      cover.className = 'gm-catalog__hit-cover';
      /* Корицата вече идва през НАШ адрес — `/apps/gramofonika/cover?ean=…`, — а
         не право от JPC. Това реши стария проблем: техният адрес връщаше два
         различни файла — без Referer чист, с Referer от нашия магазин със сива
         лента «www.jpc.de» през долната четвърт. Браузърът на клиента винаги праща
         Referer, значи винаги щеше да получава белязания. През нашия адрес тегли
         ERP-то и файлът стига чист. Проверено на живо върху три корици. */
      if (item.image) {
        const img = document.createElement('img');
        img.alt = '';
        img.decoding = 'async';
        /* БЕЗ `loading="lazy"`. Шестте корици на страницата се раждат след
           търсене, тоест вече са «при поискване»; отложи ли се и това, браузърът
           просто не тръгва за тях и квадратчетата остават сиви до безкрай.
           Проверено: с lazy — нула заявки за дванайсет секунди; без него — 400ms. */
        /* Корицата се сглобява по баркод и не всеки баркод я има — при проба на
           трийсет шест дадоха 404. Счупената картинка се маха, за да остане
           сивото квадратче: то пази мястото и не изглежда като дефект. */
        img.addEventListener('error', () => img.remove());
        img.src = item.image;
        cover.appendChild(img);
      }

      const text = document.createElement('span');
      text.className = 'gm-catalog__hit-text';
      if (item.artist) text.appendChild(line(item.artist, 'gm-catalog__hit-artist'));
      text.appendChild(line(item.title || '', 'gm-catalog__hit-title'));
      /* Баркодът се изписва до изданието. По него човек познава ТОЧНО кое
         издание е — «Blue Train» има десетки преиздания и жанрът «Jazz» не ги
         различава. Не се повтаря, ако вече стои в самото издание. */
      const bits = [];
      if (item.meta) bits.push(item.meta);
      if (item.ref && !(item.meta || '').includes(item.ref)) bits.push(item.ref);
      if (bits.length) text.appendChild(line(bits.join(' · '), 'gm-catalog__hit-meta'));

      const side = document.createElement('span');
      side.className = 'gm-catalog__hit-side';

      /* Каталогът връща и заглавия, които вече са НАШИ издания — човек може да
         търси плоча, която стои на витрината, само че изчерпана. Да ги крием е
         по-лошо: тогава търсенето казва «нищо не се намери» за нещо, което
         имаме.

         Такъв ред обаче не води към заявка от каталог, а към самата плоча: там
         петте състояния на доставката вече знаят какво да предложат — купи,
         заяви, уведоми ме или нищо.

         Цената на доставчика не се показва при наши издания. Тя е нето, без
         ДДС и без наценка, тоест до нашето заглавие изглежда като по-добра
         оферта на същата плоча. */
      /* При наше издание надписът се изписва ЧАК след проверката. «Имаме я»
         означава само, че ERP-то е разпознало заглавието като наше — не че се
         продава. Дали се продава казва самата карта в магазина, а тя може и
         изобщо да я няма (голяма част от плочите още са чернови). Затова
         клетката стои празна, докато не се разбере кое от трите е. */
      /* «Наша» е само тази, за която ERP-то дава И адрес. Без адрес твърдението
         е непроверимо и неизползваемо: не можем нито да го покажем, нито да
         заведем човека някъде. Тогава редът се държи като всеки друг от
         каталога — със срок, цена и «Заяви», — вместо да носи надпис, който не
         води доникъде. */
      const ours = Boolean(item.owned && item.handle);

      /* Никакъв нарочен линк — ЦЕЛИЯТ РЕД е вратата (решение на Кирил,
         05.09): при наша карта отваря плочата, иначе — мини страницата от
         каталога, ако търсенето е дало адрес (поле url; езикът се добавя
         тук, каталогът връща голия път). Бутоните вътре не пътуват: клик
         върху «Заяви» си остава «Заяви». */
      const catalogUrl = () => {
        if (!item.url) return '';
        const bits = [];
        // Търсеното пътува с адреса: мини страницата го връща в «Обратно
        // към каталога» и връщането заварва резултатите, не празен екран.
        if (heldQuery) bits.push('q=' + encodeURIComponent(heldQuery));
        // ЕЗИКЪТ пътува САМО с пътя (втора поука от 06.09): /en/apps/…
        // носи английската обвивка, а тялото на мини страницата се превежда
        // от Shopify при сервиране по request.locale — параметър ?lang= няма
        // и разминаване тяло/черупка е невъзможно по строеж. routes.root
        // дава префикса без гадаене.
        const prefix = root_url().replace(/\/$/, '');
        return prefix + item.url + (bits.length ? '?' + bits.join('&') : '');
      };
      const rowOpens = (url) => {
        if (!url) return;
        row.classList.add('gm-catalog__hit--link');
        row.setAttribute('tabindex', '0');
        row.setAttribute('role', 'link');
        row.addEventListener('click', (event) => {
          if (event.target.closest('button, a')) return;
          window.location.href = url;
        });
        row.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' || event.target !== row) return;
          window.location.href = url;
        });
      };

      let when = null;
      if (ours) {
        when = line('', 'gm-catalog__hit-owned');
        side.appendChild(when);
      } else if (item.eta) {
        side.appendChild(line(item.eta, 'gm-catalog__hit-eta'));
      }

      /* Цената на доставчика е нето, без ДДС и без наценка. До НАША карта тя
         изглежда като по-добра оферта на същата плоча, затова там се крие. Не се
         ли стигне до картата, редът остава на доставчика и цената се показва. */
      let priceNode = null;
      if (item.price) {
        priceNode = line(item.price, 'gm-catalog__hit-price');
        if (ours) priceNode.hidden = true;
        side.appendChild(priceNode);
      }

      /* Заявката е изходът по подразбиране — включително за наше издание БЕЗ
         карта в магазина: имаме го, но човекът не може да го стигне, значи
         някой при нас трябва да погледне. */
      const requestButton = () => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gm-btn gm-btn--secondary';
        button.textContent = words.gmWordReserve;
        button.addEventListener('click', () => {
          /* Свободното поле се пълни с това, което човек вижда на реда — име и
             заглавие. Точното издание и адресът отиват в скритите полета: те са
             за ERP-то, не за четене. */
          if (what) {
            what.value = [item.artist, item.title].filter(Boolean).join(' — ');
          }

          const holder = root.querySelector('[data-gm-catalog-handle]');
          if (holder) holder.value = item.handle || '';

          const ref = root.querySelector('[data-gm-catalog-ref]');
          // Каталожният номер обикновено е и в `meta` — не се пише два пъти.
          if (ref) {
            const meta = item.meta || '';
            const extra = item.ref && !meta.includes(item.ref) ? item.ref : '';
            ref.value = [meta, extra].filter(Boolean).join(' · ');
          }

          показва({
            title: [item.artist, item.title].filter(Boolean).join(' — '),
            meta: ref ? ref.value : '',
          });

          openAsk();

          /* Превърта се САМО ако панелът не се вижда. Той стои от дясната страна
             на същия екран — превъртане при видим панел е онова «повдигане», от
             което не става ясно какво се е случило. */
          const кутия = box_ask.getBoundingClientRect();
          if (кутия.top < 0 || кутия.bottom > window.innerHeight) {
            box_ask.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }

          root.querySelector('[name="contact[email]"]')?.focus({ preventScroll: true });
        });
        return button;
      };

      if (ours) {
        /* Питаме САМАТА карта, не гадаем по адреса: `/products/<handle>.js` казва
           и дали я има, и дали се продава. Дотогава в клетката за действие не
           стои нищо — бутон, който след половин секунда се сменя с друг, е
           по-лошо от бутон, който закъснява.

           Три изхода:
           · картата се продава        → «Налична» + «Виж плочата»
           · картата я има, но не се продава → «Имаме я» + «Виж плочата»
           · карта няма (чернова, 404) → нищо + «Заяви»

           «Имаме я» НЕ значи наличност. Значи само, че ERP-то е разпознало
           заглавието като наше. Затова двата случая се разделят: инак човек чете
           «имаме я» и вижда бутон «заяви», което си противоречи. */
        const seat = document.createElement('span');
        seat.className = 'gm-catalog__hit-seat';
        side.appendChild(seat);

        fetch(root_url() + 'products/' + encodeURIComponent(item.handle) + '.js', {
          headers: { Accept: 'application/json' },
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((card) => {
            if (!card) {
              // Картата я няма (чернова). Редът се връща на доставчика.
              if (when) when.remove();
              if (priceNode) priceNode.hidden = false;
              seat.replaceWith(requestButton());
              rowOpens(catalogUrl());
              return;
            }
            if (when) {
              when.textContent = card.available ? words.gmWordAvailable : words.gmWordOwned;
              when.className = card.available
                ? 'gm-catalog__hit-instock'
                : 'gm-catalog__hit-owned';
            }
            seat.remove();
            rowOpens(root_url() + 'products/' + encodeURIComponent(item.handle));
          })
          .catch(() => {
            /* мрежата мълчи — заявката е сигурният изход */
            if (when) when.remove();
            if (priceNode) priceNode.hidden = false;
            seat.replaceWith(requestButton());
            rowOpens(catalogUrl());
          });
      } else {
        side.appendChild(requestButton());
        rowOpens(catalogUrl());
      }

      row.append(cover, text, side);
      return row;
    };

    /* Каталогът връща един пакет, не страници. Той се държи тук и се разлиства,
       за да остане полето с резултатите високо колкото е и да не бута формата
       вдясно надолу при всяко ново търсене. Колко реда на страница казва CSS —
       там е и височината на полето, за да са на едно място. */
    let held = [];
    let heldQuery = '';
    let heldTotal = 0;
    let atPage = 0;

    const perPage =
      parseInt(getComputedStyle(root).getPropertyValue('--gm-hits-rows'), 10) || 6;

    const pager = root.querySelector('[data-gm-catalog-pager]');
    const prev = root.querySelector('[data-gm-catalog-prev]');
    const next = root.querySelector('[data-gm-catalog-next]');
    const numbers = root.querySelector('[data-gm-catalog-numbers]');
    const pageSaid = root.querySelector('[data-gm-catalog-page]');
    const more = root.querySelector('[data-gm-catalog-more]');

    const render = () => {
      const pages = Math.max(1, Math.ceil(held.length / perPage));
      atPage = Math.min(Math.max(atPage, 0), pages - 1);

      const from = atPage * perPage;
      const slice = held.slice(from, from + perPage);

      list.replaceChildren();
      for (const item of slice) list.appendChild(drawRow(item));

      /* Броячът показва обхвата на страницата И общия брой намерени. Покаже ли
         броя на изчертаните, човек не разбира, че има още — и уточнява търсенето
         само защото не е намерил, а не защото е отрязано. */
      if (heldTotal === 1) {
        count.textContent = (words.gmWordFoundOne || '')
          .replace('{n}', heldTotal)
          .replace('{q}', heldQuery);
      } else {
        count.textContent = (words.gmWordRange || '')
          .replace('{from}', from + 1)
          .replace('{to}', from + slice.length)
          .replace('{n}', heldTotal)
          .replace('{q}', heldQuery);
      }

      /* Разликата между върнатото и намереното се казва изрично — но чак на
         последната страница, там където списъкът свършва. На първата «показани са
         първите 24» звучи като че ли това са всичките. */
      if (more) {
        const truncated = heldTotal > held.length;
        more.textContent = truncated
          ? (words.gmWordMore || '').replace('{n}', held.length)
          : '';
        more.hidden = !truncated;
      }

      /* Постоянната височина е нужна САМО когато има какво да се разлиства: при
         три намерени реда празно поле до долу изглежда като счупено. */
      box.classList.toggle('gm-catalog__results--paged', pages > 1);

      if (!pager) return;
      pager.hidden = pages < 2;
      if (pages < 2) return;

      if (pageSaid) {
        pageSaid.textContent = (words.gmWordPage || '')
          .replace('{n}', atPage + 1)
          .replace('{m}', pages);
      }
      if (prev) prev.disabled = atPage === 0;
      if (next) next.disabled = atPage === pages - 1;

      if (numbers) {
        numbers.replaceChildren();
        for (let i = 0; i < pages; i += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = i === atPage ? 'gm-btn gm-btn--primary' : 'gm-btn gm-btn--secondary';
          button.textContent = String(i + 1);
          button.setAttribute('aria-current', i === atPage ? 'true' : 'false');
          button.addEventListener('click', () => {
            atPage = i;
            render();
          });
          numbers.appendChild(button);
        }
      }
    };

    prev?.addEventListener('click', () => {
      atPage -= 1;
      render();
    });

    next?.addEventListener('click', () => {
      atPage += 1;
      render();
    });

    let busy = false;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const query = input.value.trim();
      if (!query || busy) return;

      busy = true;
      say(words.gmWordSearching);

      try {
        const response = await fetch(root_url() + 'apps/gramofonika/catalog', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ query }),
        });
        const data = await response.json().catch(() => ({}));

        if (!response.ok || !data.success) {
          say(words.gmWordError);
        } else if (!data.items || !data.items.length) {
          say(words.gmWordNone);
        } else {
          held = data.items;
          heldQuery = query;
          heldTotal = typeof data.count === 'number' ? data.count : data.items.length;
          atPage = 0;
          render();
          box.hidden = false;
          /* Търсеното застава в адреса (без презареждане): «Назад» на
             браузъра и връщането от мини страница попадат на СЪЩИТЕ
             резултати, а адресът става споделим. */
          try {
            history.replaceState(null, '', window.location.pathname + '?q=' + encodeURIComponent(query));
          } catch (error) {}
        }
      } catch (error) {
        say(words.gmWordError);
      } finally {
        busy = false;
      }
    });

    /* Дошъл с ?q= в адреса — връщане от мини страница или споделен линк:
       търсенето тръгва само и човекът заварва резултатите, не празно поле.
       Стои НАКРАЯ, след като слушателят на формата вече е закачен. */
    const asked = fromUrl.get('q');
    if (asked && input) {
      input.value = asked;
      form.requestSubmit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gramofonika-collection"]) return;
  try {
    
  // Падащите в реда с контроли са ЕДНА група: «Подреди» и — на телефон, където
  // идва при него — «Филтри». `details` сам по себе си остава отворен, а два
  // отворени панела един до друг изглеждат счупено.
  //
  // Филтрите се броят само докато са в този ред: на десктоп панелът им стои
  // отворен в своята колона и няма какво да се затваря.
  // Обвивката пази глобалния обхват: `{% javascript %}` се слива в един файл.
  (() => {
  const openInRow = () =>
    document.querySelectorAll('[data-gm-controls] details[open]');

  // `toggle` не бълбука — слуша се в capture фазата.
  document.addEventListener(
    'toggle',
    (event) => {
      const opened = event.target;
      if (!opened.open) return;
      const row = opened.closest?.('[data-gm-controls]');
      if (!row) return;
      row.querySelectorAll('details[open]').forEach((other) => {
        if (other !== opened) other.open = false;
      });
    },
    true
  );

  document.addEventListener('click', (event) => {
    openInRow().forEach((box) => {
      if (!box.contains(event.target)) box.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    openInRow().forEach((box) => {
      box.open = false;
      box.querySelector('summary')?.focus();
    });
  });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gramofonika-genres-index"] && !Shopify.designMode) return;
  try {
    
  /*
    Ротация на обложките.

    Liquid рисува три обложки и носи набор от дванайсет — толкова дава той извън
    страниране. При жанр с хиляди плочи това не е разнообразие, а същите
    дванайсет в различен ред. Затова наборът се РАЗШИРЯВА от секцията
    `gramofonika-genre-shots`: случайна страница от целия жанр, около 800 байта.

    Заявката тръгва чак когато картата наближи екрана. Дотогава обложките ѝ и
    без това не са свалени (mързеливо зареждане), тоест подмяната не хаби нищо.

    Без JavaScript страницата пак работи — тогава са първите три от Liquid.
  */
  document.querySelectorAll('[data-gm-genres]').forEach((grid) => {
    const mode = grid.dataset.gmRotate;
    if (!mode || mode === 'off') return;

    const cards = [...grid.querySelectorAll('[data-gm-genre]')];
    if (!cards.length) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const PER_PAGE = 12;

    const poolOf = (card) => (card.dataset.gmPool || '').split('|').filter(Boolean);

    /* Случайна страница от жанра. Броят страници се знае приблизително от броя
       плочи и се уточнява от самия отговор. Празен отговор значи, че сме поискали
       страница отвъд края — тогава остава каквото има. */
    const widen = async (card) => {
      const handle = card.dataset.gmHandle;
      if (!handle || card.dataset.gmFetching === 'true') return;

      const known = Number(card.dataset.gmPages || 0);
      const count = Number(card.dataset.gmCount || 0);
      const pages = known || Math.ceil(count / PER_PAGE);
      if (pages < 2) return;

      card.dataset.gmFetching = 'true';
      try {
        const page = 1 + Math.floor(Math.random() * pages);
        const url =
          root + 'collections/' + encodeURIComponent(handle) +
          '?section_id=gramofonika-genre-shots&page=' + page;

        const html = await fetch(url).then((r) => (r.ok ? r.text() : ''));
        if (!html) return;

        const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gm-shots]');
        if (!box) return;

        if (box.dataset.gmPages) card.dataset.gmPages = box.dataset.gmPages;

        const fresh = box.textContent.trim().split('|').filter(Boolean);
        if (fresh.length) card.dataset.gmPool = fresh.join('|');
      } catch (error) {
        /* мрежата мълчи — остава наборът от Liquid */
      } finally {
        card.dataset.gmFetching = 'false';
      }
    };

    const swap = (tile, url, animate) => {
      let img = tile.querySelector('img');
      if (img && img.getAttribute('src') === url) return;

      const put = () => {
        if (!img) {
          img = document.createElement('img');
          img.className = 'gm-genre__image';
          img.alt = '';
          img.width = 400;
          img.height = 400;
          img.decoding = 'async';
          tile.appendChild(img);
        }
        img.src = url;
      };

      if (!animate || calm) {
        put();
        return;
      }

      // Новата обложка се сваля ПРЕДИ гасенето, иначе плочката остава празна,
      // докато тя пътува.
      const next = new Image();
      next.onload = () => {
        tile.style.opacity = '0';
        setTimeout(() => {
          put();
          tile.style.opacity = '';
        }, 220);
      };
      next.onerror = put;
      next.src = url;
    };

    const shuffle = (card, animate) => {
      const pool = poolOf(card);
      const tiles = [...card.querySelectorAll('.gm-genre__tile')];
      if (pool.length <= tiles.length) return;

      const taken = new Set();
      while (taken.size < tiles.length) taken.add(Math.floor(Math.random() * pool.length));
      [...taken].forEach((index, i) => swap(tiles[i], pool[index], animate));
    };

    /* Картата се пипа веднъж, когато наближи екрана: първо се разширява наборът,
       после се раздават обложките. Смяната тук е мигновена — избледняване преди
       човекът да е видял картата изглежда като засечка. */
    const seen = new WeakSet();
    const wake = async (card) => {
      if (seen.has(card)) return;
      seen.add(card);
      await widen(card);
      shuffle(card, false);
    };

    if ('IntersectionObserver' in window) {
      const watcher = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            watcher.unobserve(entry.target);
            wake(entry.target);
          }
        },
        { rootMargin: '300px' }
      );
      for (const card of cards) watcher.observe(card);
    } else {
      for (const card of cards) wake(card);
    }

    if (mode !== 'timer') return;

    /* При таймера се сменя ЕДНА карта на такт, не всичките: петнайсет
       едновременни смени са слайдшоу, а една тиха смяна се чете като жив
       магазин. През няколко такта се тегли и нова страница, за да не се върти
       все една и съща шепа. */
    const seconds = Number(grid.dataset.gmRotateSeconds) || 8;
    let tick = 0;

    setInterval(async () => {
      if (document.visibilityState !== 'visible') return;

      const shown = cards.filter((card) => {
        const box = card.getBoundingClientRect();
        return box.bottom > 0 && box.top < window.innerHeight;
      });
      if (!shown.length) return;

      const card = shown[Math.floor(Math.random() * shown.length)];
      tick += 1;
      if (tick % 5 === 0) await widen(card);
      shuffle(card, true);
    }, seconds * 1000);
  });

  // Подредбата е поглед, не заявка: картите вече са изчертани, тук само сменят
  // местата си. Затова няма презареждане и няма адрес, който да се помни.
  document.querySelectorAll('[data-gm-genres]').forEach((grid) => {
    const sort = (mode) => {
      const cards = [...grid.querySelectorAll('[data-gm-genre]')];
      cards.sort((a, b) =>
        mode === 'count'
          ? Number(b.dataset.gmCount) - Number(a.dataset.gmCount)
          : a.dataset.gmName.localeCompare(b.dataset.gmName, document.documentElement.lang || 'bg')
      );
      for (const card of cards) grid.appendChild(card);
      grid.dataset.gmSort = mode;
    };

    sort(grid.dataset.gmSort || 'name');

    const section = grid.closest('.gm-genres-index');
    section?.querySelectorAll('[data-gm-genre-sort]').forEach((button) => {
      button.addEventListener('click', () => {
        for (const other of section.querySelectorAll('[data-gm-genre-sort]')) {
          other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
        }
        sort(button.dataset.gmGenreSort);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gramofonika-preorder"] && !Shopify.designMode) return;
  try {
    
  // Месецът е поглед към същия списък: групите вече са изчертани, бутонът само
  // крие останалите. Затова няма презареждане.
  document.querySelectorAll('.gm-preorder').forEach((section) => {
    section.querySelectorAll('[data-gm-month]').forEach((button) => {
      button.addEventListener('click', () => {
        const wanted = button.dataset.gmMonth;

        for (const other of section.querySelectorAll('[data-gm-month]')) {
          other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
        }
        for (const group of section.querySelectorAll('[data-gm-month-group]')) {
          group.hidden = wanted !== 'all' && group.dataset.gmMonthGroup !== wanted;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gramofonika-product"]) return;
  try {
    
  // Сгъването на долния ред. Бутонът се ражда скрит — без JavaScript всичко
  // стои разгънато. Всеки продукт започва СГЪНАТ; нищо не се помни между
  // страниците (решение на Кирил — наследяването от последния продукт бърка).
  // ДВЕ контроли за едно тяло: лентата отдолу и «i» до изпълнителя. Затова
  // бутоните се групират по тялото, което движат — иначе всеки пази свое
  // «отворено ли е» и вторият клик тръгва от грешната страна.
  // Лепкавата шапка виси над съдържанието: знак, застанал под нея, е скрит,
  // макар и «в кадъра». Височината ѝ се вади и при авто-свиването, и при
  // лепенето на табовете — затова се мери на едно място.
  const gmShadeTop = () => {
    let h = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach((el) => {
      if (getComputedStyle(el).position === 'sticky') h += el.getBoundingClientRect().height;
    });
    return h;
  };

  const gmMoreGroups = new Map();
  document.querySelectorAll('[data-gm-more]').forEach((t) => {
    const id = t.getAttribute('aria-controls');
    if (!gmMoreGroups.has(id)) gmMoreGroups.set(id, []);
    gmMoreGroups.get(id).push(t);
  });

  gmMoreGroups.forEach((toggles, bodyId) => {
    const body = document.getElementById(bodyId);
    if (!body) return;
    const toggle = toggles[0];

    const apply = (open, instant) => {
      if (instant) body.classList.add('gm-more--instant');
      body.classList.toggle('is-closed', !open);
      toggles.forEach((t) => t.setAttribute('aria-expanded', String(open)));
      if (instant) {
        // Принудителен флъш, ДОКАТО заглушителят е на класа: без него
        // браузърът смята стиловете чак след кадъра, заглушителят вече е
        // махнат и «мигновеното» сгъване тайно тръгва като 380 мс преход —
        // екранът реже горе, а дъното на кадъра още мърда и подскача.
        void body.offsetHeight;
        requestAnimationFrame(() => body.classList.remove('gm-more--instant'));
      }
    };

    let open = false;
    apply(open, true);
    toggles.forEach((t) => { t.hidden = false; });

    const onClick = () => {
      open = !open;
      settling = performance.now() + 700;

      // Horizon заключва документа (html е overflow:hidden) и скролва
      // вътрешният .page-wrapper — на прозореца е безсмислено да се говори.
      const scroller = (() => {
        let el = toggle.parentElement;
        while (el && el !== document.body) {
          const cs = getComputedStyle(el);
          if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight) return el;
          el = el.parentElement;
        }
        return document.scrollingElement;
      })();

      // Двете посоки са огледални плъзгания: разгъването — до лентата
      // («Скрий детайлите» застава най-горе), сгъването — до върха на
      // страницата. Съдържанието междувременно расте или се свива 380 мс,
      // затова НЕ се разчита на вградения smooth: пуснат веднага, той се
      // реже до моментния таван и спира накриво. Плъзгаме сами, кадър по
      // кадър, малко по-дълго от прехода — последният кадър идва след него
      // и застава точно. 'instant' във всяка стъпка надвива CSS
      // scroll-behavior: smooth на обвивката.
      // Целта на плъзгането е ЛЕНТАТА с «×», не тялото: тя стои НАД него и
      // спре ли се на тялото, затварящият знак остава над кадъра — човек
      // вижда трак листа, но не и с какво да го прибере.
      const bar = body.parentElement.querySelector('.gm-more__bar') || body;
      // Шапката е лепкава и виси над съдържанието — лента, застанала на
      // голата нула, се пъха ПОД нея. Целта слиза с моментната ѝ височина.
      // В групата на шапката има и промо лента (static) — брои се само
      // лепкавото.
      const shade = () => {
        let h = 0;
        document.querySelectorAll('.shopify-section-group-header-group').forEach((el) => {
          if (getComputedStyle(el).position === 'sticky') h += el.getBoundingClientRect().height;
        });
        return h;
      };
      // КОТВАТА зависи от това КОЙ скролва. На десктоп скролва вътрешната
      // кутия (.page-wrapper) — ръбът ѝ стои на 0 и rect.top ѝ е котва. На
      // телефон скролва САМИЯТ документ: неговият rect.top е МИНУС
      // изминатото, и извадено, то се добавя втори път — целта бягаше с
      // два пъти скрола («тотално различни места», улов на Кирил, 06.09).
      // За документа котвата е голата нула.
      const anchor = () => (scroller === document.scrollingElement ? 0 : scroller.getBoundingClientRect().top);
      const target = open
        ? () => bar.getBoundingClientRect().top - anchor() + scroller.scrollTop - shade()
        : () => 0;

      const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      apply(open, still);
      if (still) {
        scroller.scrollTo({ top: target(), behavior: 'instant' });
      } else {
        const t0 = performance.now(), from = scroller.scrollTop, dur = 420;
        const ease = (k) => 1 - Math.pow(1 - k, 3);
        const step = (now) => {
          const k = Math.min(1, (now - t0) / dur);
          scroller.scrollTo({ top: from + (target() - from) * ease(k), behavior: 'instant' });
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    };

    toggles.forEach((t) => t.addEventListener('click', onClick));

    // СВИВАНЕ ПРИ ВРЪЩАНЕ НАГОРЕ. Разгънатият лист стоеше отворен, дори
    // когато човек се качи над него — и следващото натискане на знака го
    // ЗАТВАРЯШЕ, вместо да го отвори, защото той всъщност си беше отворен
    // (улов на Кирил, 27.09).
    //
    // Мери се МЯСТОТО на ЗНАКА, не посоката на скрола: посоката лъже при
    // инерция и при плъзгането, което самото отваряне пуска.
    //
    // Прагът е самият знак: листът се прибира чак когато бутонът, който го
    // отваря, се покаже под шапката. По-рано мерех тялото на 40% от екрана и
    // свиването идваше подраненo — листът изчезваше, докато знакът още го
    // няма и човек не вижда с какво да го върне (улов на Кирил, 27.09).
    //
    // IntersectionObserver тук не става: Horizon заключва документа
    // (`html` е overflow:hidden) и движи `.page-wrapper`, а наблюдателят не
    // се задейства нито веднъж — проверено и с прозореца, и със самата
    // кутия за рамка.
    const host = (() => {
      let el = body.parentElement;
      while (el && el !== document.body) {
        const cs = getComputedStyle(el);
        if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight) return el;
        el = el.parentElement;
      }
      return document.scrollingElement;
    })();

    // Докато плъзгането от самото отваряне тече, тялото ОЩЕ е долу и
    // проверката би го затворила в мига, в който се е отворило. Затова тя
    // мълчи, докато движението не спре — прагът е малко над неговите 420 мс.
    let settling = 0;
    // Бутонът, който ОТВАРЯ — този извън лентата с «×».
    const opener = toggles.find((t) => !t.closest('.gm-more__bar')) || toggles[0];

    const watchUp = () => {
      if (!open) return;
      if (performance.now() < settling) return;
      if (opener.getBoundingClientRect().bottom <= gmShadeTop()) return;
      open = false;
      apply(open, true);
    };

    (host === document.scrollingElement ? window : host)
      .addEventListener('scroll', watchUp, { passive: true });
  });


  // Двата таба на телефон. Разметката ги ражда скрити; тук се включват САМО
  // под 750px, и се изключват обратно, ако екранът се разшири (завъртян
  // телефон, отворен таблет). На широк екран панелите са КОЛОНИ — затова
  // `role`-ите им се слагат и махат заедно с табовете, вместо да стоят
  // постоянно в разметката и да лъжат четеца.
  document.querySelectorAll('[data-gm-tabs]').forEach((tabs) => {
    const bottom = tabs.parentElement.querySelector('.gm-product__bottom');
    if (!bottom) return;

    const buttons = [...tabs.querySelectorAll('[data-gm-tab]')];
    const panels = buttons.map((b) => document.getElementById(b.getAttribute('aria-controls')));
    if (panels.some((panel) => !panel)) return;

    const narrow = matchMedia('(max-width: 749px)');
    let picked = 'tracks';

    const paint = () => {
      bottom.dataset.gmTab = picked;
      buttons.forEach((b) => {
        const on = b.dataset.gmTab === picked;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        // Един таб в реда на клавиатурата, както е редно за tablist: в
        // избрания се влиза с Tab, между табовете се минава със стрелки.
        b.tabIndex = on ? 0 : -1;
      });
      panels.forEach((panel, i) => {
        panel.setAttribute('tabindex', buttons[i].dataset.gmTab === picked ? '0' : '-1');
      });
    };

    // Колко да отстъпи лепкавият ред: точно колкото виси шапката. Числото се
    // изнася като променлива, защото лепенето е CSS, а височината се знае чак
    // в браузъра. Мери се наново при всяко разширяване — шапката на телефон и
    // на таблет не е еднакво висока.
    const shade = () => tabs.style.setProperty('--gm-shade', gmShadeTop() + 'px');

    const wire = (on) => {
      tabs.hidden = !on;
      if (on) shade();
      panels.forEach((panel, i) => {
        if (on) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', buttons[i].id);
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        }
      });
      if (on) paint();
      else delete bottom.dataset.gmTab;
    };

    // Смяна на таб с вдигнат нагоре екран: дългият лист изчезва, страницата се
    // свива под краката ти и оставаш ПОД панела, сред препоръките. Проверено —
    // от «Страна D» натискането на «Детайли» те изхвърля в «Може да ти хареса».
    // Затова, щом панелът е започнал над кадъра, той се връща точно под
    // шапката: редът с табовете остава там, където е бил натиснат.
    const keepInView = () => {
      const shadeNow = gmShadeTop();
      // Началото на ПАНЕЛА, не на лепкавия ред — редът лъже, докато е залепен.
      const top = tabs.parentElement.getBoundingClientRect().top;
      if (top >= shadeNow) return;
      scrollTo({ top: scrollY + top - shadeNow, behavior: 'instant' });
    };

    tabs.addEventListener('click', (event) => {
      const button = event.target.closest('[data-gm-tab]');
      if (!button) return;
      picked = button.dataset.gmTab;
      paint();
      keepInView();
    });

    tabs.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const at = buttons.findIndex((b) => b.dataset.gmTab === picked);
      const next = buttons[(at + (event.key === 'ArrowRight' ? 1 : buttons.length - 1)) % buttons.length];
      picked = next.dataset.gmTab;
      paint();
      keepInView();
      next.focus();
    });

    narrow.addEventListener('change', () => wire(narrow.matches));
    addEventListener('resize', () => {
      if (narrow.matches) shade();
    }, { passive: true });
    wire(narrow.matches);
  });


  // Редовете, които зависят от варианта. Horizon съобщава смяната със събитие
  // shopify:product:select върху секцията с продукта; носи обект на варианта, от
  // който взимаме само id-то, а надписите идват от готовия набор по-горе.
  document.querySelectorAll('[data-gm-variant-facts]').forEach((store) => {
    let facts;
    try {
      facts = JSON.parse(store.textContent);
    } catch (error) {
      return;
    }

    const scope = store.closest('.gm-product') || document;

    const apply = (variantId) => {
      const row = facts[String(variantId)];
      if (!row) return;

      Object.keys(row).forEach((key) => {
        scope.querySelectorAll('[data-gm-fact="' + key + '"]').forEach((cell) => {
          cell.textContent = row[key];
        });
        scope.querySelectorAll('[data-gm-fact-row="' + key + '"]').forEach((wrapper) => {
          wrapper.hidden = row[key] === '';
        });
      });
    };

    const onSelect = (event) => {
      const use = (detail) => {
        const id = detail && detail.resource && detail.resource.id;
        if (id) apply(id);
      };

      if (event.promise && typeof event.promise.then === 'function') {
        event.promise.then((result) => use(result && result.detail)).catch(() => {});
      } else {
        use(event.detail);
      }
    };

    const target = store.closest('[id*="ProductInformation-"]') || document;
    target.addEventListener('shopify:product:select', onSelect);
  });
  // Броячът на продуктовата страница е на Horizon. Тук му се слага таванът от
  // кошницата, за да не се стига до касата с повече, отколкото продаваме.
  document.querySelectorAll('[data-gm-limit]').forEach((root) => {
    const limit = parseInt(root.dataset.gmLimit, 10);
    if (!limit) return;

    root.querySelectorAll('input[name="quantity"]').forEach((field) => {
      field.max = limit;
      field.addEventListener('change', () => {
        if (parseInt(field.value, 10) > limit) field.value = limit;
      });
    });
  });

  // Големият изглед: обложката се отваря на цял екран, стрелките и клавишите
  // минават между снимките. Списъкът идва от JSON в галерията — нищо не се
  // тегли, докато прозорецът не се отвори.
  document.querySelectorAll('[data-gm-gallery]').forEach((gallery) => {
    const store = gallery.querySelector('[data-gm-media]');
    const lb = document.querySelector('[data-gm-lb]');
    if (!store || !lb) return;

    let shots = [];
    try {
      shots = JSON.parse(store.textContent) || [];
    } catch (e) {
      return;
    }
    if (!shots.length) return;

    const img = lb.querySelector('[data-gm-lb-image]');
    const prev = lb.querySelector('[data-gm-lb-prev]');
    const next = lb.querySelector('[data-gm-lb-next]');
    const count = lb.querySelector('[data-gm-lb-count]');
    const closer = lb.querySelector('[data-gm-lb-close]');
    let at = 0;
    let opener = null;

    const paint = () => {
      img.src = shots[at];
      if (shots.length > 1) {
        prev.hidden = false;
        next.hidden = false;
        count.hidden = false;
        count.textContent = at + 1 + ' / ' + shots.length;
      }
    };

    const step = (by) => {
      at = (at + by + shots.length) % shots.length;
      paint();
    };

    const open = (i) => {
      at = i;
      opener = document.activeElement;
      lb.hidden = false;
      // Скролът отзад се заключва, иначе страницата се движи под прозореца.
      document.documentElement.style.overflow = 'hidden';
      paint();
      closer.focus();
    };

    const close = () => {
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      img.removeAttribute('src');
      if (opener && opener.focus) opener.focus();
    };

    gallery.querySelectorAll('[data-gm-open]').forEach((btn) => {
      btn.addEventListener('click', () => {
        // Всяка снимка от лентата си е отделен бутон, тоест натиснатата е и
        // видимата — индексът се чете от нея, без заобикалки през миниатюрите.
        open(Number(btn.dataset.gmIndex) || 0);
      });
    });

    closer.addEventListener('click', close);
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));

    // Натискане върху фона затваря; върху самата снимка — не.
    lb.addEventListener('click', (event) => {
      if (event.target === lb) close();
    });

    document.addEventListener('keydown', (event) => {
      if (lb.hidden) return;
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowLeft') step(-1);
      else if (event.key === 'ArrowRight') step(1);
    });

    // Плъзгане с пръст, със същия праг като в героя: 40px хоризонтално и
    // повече от вертикалното, за да не сменя снимка при обикновен скрол.
    let tx = 0;
    let ty = 0;
    lb.addEventListener('touchstart', (event) => {
      tx = event.changedTouches[0].clientX;
      ty = event.changedTouches[0].clientY;
    }, { passive: true });
    lb.addEventListener('touchend', (event) => {
      const dx = event.changedTouches[0].clientX - tx;
      const dy = event.changedTouches[0].clientY - ty;
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
      step(dx < 0 ? 1 : -1);
    }, { passive: true });
  });

  // Лентата със снимките. Самото плъзгане е роден скрол със залепване —
  // скриптът само държи миниатюрите в крак с нея и ги прави нейни бутони.
  document.querySelectorAll('[data-gm-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gm-track]');
    if (!track) return;

    const thumbs = Array.from(gallery.querySelectorAll('[data-gm-thumb]'));

    const mark = (i) => {
      gallery.dataset.gmAt = i;
      thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-on', Number(thumb.dataset.gmIndex) === i);
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        // Скокът е МИГНОВЕН, не плавен: залепващата лента не приема плавен
        // програмен скрол — проверено на живо, `scrollTo` с `smooth` и
        // `scroll-behavior: smooth` не мърдат нито пиксел, докато пряката
        // стойност работи. Пък и подмяната на снимката открай време е мигновена.
        const i = Number(thumb.dataset.gmIndex) || 0;
        track.scrollLeft = i * track.clientWidth;
        mark(i);
      });
    });

    // Скролът се обажда десетки пъти в секунда — сметката е веднъж на кадър.
    let waiting = 0;
    track.addEventListener('scroll', () => {
      if (waiting) return;
      waiting = requestAnimationFrame(() => {
        waiting = 0;
        if (!track.clientWidth) return;
        mark(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { passive: true });
  });

  // Откъсите в трак листа: 30 секунди от Deezer, БЕЗ виджет (решение на
  // Кирил). Адресът на откъса ИЗТИЧА, затова не се складира никъде — взима
  // се при натискане, през JSONP: api.deezer.com не праща CORS заглавка,
  // а самият MP3 праща и <audio> го свири. Един плеър за цялата страница —
  // ново натискане спира предишното парче.
  (() => {
    const buttons = [...document.querySelectorAll('[data-gm-play]')];
    if (!buttons.length) return;

    // Мини плеърът под обложката кара СЪЩИТЕ копчета. Затова тук няма втори
    // звук и второ състояние — само трети начин да се натиснат.
    const bar = document.querySelector('[data-gm-preview]');
    const key = bar && bar.querySelector('[data-gm-preview-go="play"]');
    const face = bar && {
      n: bar.querySelector('[data-gm-preview-n]'),
      title: bar.querySelector('[data-gm-preview-title]'),
      echo: bar.querySelector('[data-gm-preview-echo]'),
      pos: bar.querySelector('[data-gm-preview-pos]'),
      fill: bar.querySelector('[data-gm-preview-fill]'),
    };

    // Заглавието се чете от реда в трак листа — един източник, и плеърът не
    // може да се размине с листа.
    //
    // Номерът обаче НЕ се чете оттам: в реда стои «1», защото буквата на
    // страната е горе, в заглавието на групата («СТРАНА A»). Плеърът няма
    // такова заглавие, значи му трябва цялото обозначение — «A1». Затова то
    // пътува на самото копче, както го е дало ERP-то (улов на Кирил, 28.09).
    const said = (button) => {
      const row = button && button.closest('.gm-track');
      return {
        n: (button && button.dataset.gmN)
          || (row && row.querySelector('.gm-track__n')?.textContent.trim())
          || '',
        title: (row && row.querySelector('.gm-track__title')?.textContent.trim()) || '',
      };
    };

    const audio = new Audio();
    audio.preload = 'none';
    let playing = null;
    // Докъде е стигнал човекът. Пази се и след спиране, за да продължи
    // «напред» оттам, а не от началото на плочата.
    let cursor = 0;

    const mark = (button, on) => { if (button) button.classList.toggle('is-playing', on); };

    // ДЪЛГИТЕ ЗАГЛАВИЯ СЕ ПРЕВЪРТАТ (Кирил, 28.09). Отрязаното с многоточие
    // заглавие скрива тъкмо различаващата част: «Freedom Now Suite, Pt. 1» и
    // «…, Pt. 2» се четат еднакво.
    //
    // В КРЪГ, не напред-назад. Първо го направих да отива и да се връща и
    // Кирил го отряза — с право: връщането е движение, което не носи нищо за
    // четене, а окото го следи. В кръг текстът тръгва само в една посока и
    // краят му се подава пак отдясно.
    //
    // Затова текстът стои ДВА ПЪТИ. Пистата се мести точно с дължината на един
    // бяг и се връща в нулата; шевът не личи, защото на негово място вече стои
    // второто копие. Същото е и при дрифт-лентата с кориците на паролната
    // страница. Междината е отстъп НА БЯГА, не разстояние между двата: иначе
    // последната обиколка залепва за първата.
    //
    // Мери се ТУК, а не в CSS: дали текстът се побира, зависи от самия текст и
    // от ширината на екрана, и CSS не може да ги сравни.
    //
    // Скоростта е ПИКСЕЛИ В СЕКУНДА, не време за обиколка: дълго и късо
    // заглавие вървят еднакво бързо, само дългото пътува по-дълго. 24 px/s е
    // близо до дрифт-лентата (25) — спокойно четене, не бягане.
    const slow = matchMedia('(prefers-reduced-motion: reduce)');
    const GM_ROLL_GAP = 40;
    const GM_ROLL_SPEED = 24;
    const roll = () => {
      if (!face || !face.title) return;
      const box = face.title.parentElement.parentElement;
      box.classList.remove('is-rolling');
      box.style.removeProperty('--gm-roll');
      box.style.removeProperty('--gm-roll-time');
      face.title.removeAttribute('title');
      if (face.echo) face.echo.textContent = '';
      if (slow.matches) return;

      // Мери се БЕЗ второто копие и без междината — иначе кутията се сравнява
      // с два текста и всяко заглавие излиза «твърде дълго».
      const run = face.title.getBoundingClientRect().width;
      if (run - box.clientWidth <= 1) return;

      if (face.echo) face.echo.textContent = face.title.textContent;
      const step = run + GM_ROLL_GAP;
      box.style.setProperty('--gm-roll', step.toFixed(1) + 'px');
      box.style.setProperty('--gm-roll-time', (step / GM_ROLL_SPEED).toFixed(1) + 's');
      box.classList.add('is-rolling');
      // Движещият се текст не се чете наведнъж — подсказката го дава цял.
      face.title.setAttribute('title', face.title.textContent);
    };

    // Ширината се мени и без смяна на парче: завъртян телефон, разтеглен
    // прозорец, лепването под шапката.
    addEventListener('resize', roll, { passive: true });

    const paint = () => {
      if (!key) return;
      const on = playing !== null;
      key.classList.toggle('is-playing', on);
      key.setAttribute('aria-pressed', on ? 'true' : 'false');
      key.setAttribute('aria-label', on ? bar.dataset.gmLabelStop : bar.dataset.gmLabelPlay);

      // Лентата показва ТЕКУЩОТО парче и когато нищо не свири: човек трябва да
      // вижда какво ще тръгне, преди да натисне.
      const button = playing || buttons[cursor];
      const words = said(button);
      face.n.textContent = words.n;
      face.title.textContent = words.title;
      face.pos.textContent = (buttons.indexOf(button) + 1) + ' / ' + buttons.length;
      if (!on) face.fill.style.width = '0';

      // Заглавието се премерва СЛЕД като е сменено: дали се побира, зависи от
      // текста, а той тъкмо се е променил.
      roll();
    };

    // Чертата върви по времето на САМИЯ откъс, не по брояч: спре ли се,
    // продължи ли — мястото ѝ е вярно. Тя е единственото, което показва докъде
    // е стигнало парчето, откакто числата паднаха.
    audio.addEventListener('timeupdate', () => {
      if (!face || playing === null) return;
      const total = audio.duration && isFinite(audio.duration) ? audio.duration : 30;
      face.fill.style.width = Math.min(100, (audio.currentTime / total) * 100) + '%';
    });

    const halt = () => {
      audio.pause();
      mark(playing, false);
      playing = null;
      paint();
      if (bar) bar.dispatchEvent(new CustomEvent('gm:perch'));
    };

    audio.addEventListener('ended', halt);

    const preview = (id) => new Promise((ok, bad) => {
      const name = 'gmDz' + String(id).replace(/\D/g, '') + '_' + Date.now().toString(36);
      const tag = document.createElement('script');
      window[name] = (data) => {
        delete window[name];
        tag.remove();
        if (data && data.preview) ok(data.preview);
        else bad(new Error('няма откъс'));
      };
      tag.onerror = () => { delete window[name]; tag.remove(); bad(new Error('мълчи')); };
      tag.src = 'https://api.deezer.com/track/' + encodeURIComponent(id) + '?output=jsonp&callback=' + name;
      document.head.appendChild(tag);
    });

    // Адресът на откъса се взима ПРЕДВАРИТЕЛНО, а не в мига на натискането.
    // Причината не е бързина, а разрешение: `audio.play()` минава само докато
    // жестът на човека още важи, а една мрежова обиколка до Deezer го изразходва.
    // На десктоп браузърът прощава; iOS — не. Затова първото парче се затопля
    // на празен ход, а щом нещо засвири, се затоплят съседите му.
    const warm = (button) => {
      if (!button || button.disabled || button.dataset.gmUrl) return;
      preview(button.dataset.gmPlay)
        .then((url) => { button.dataset.gmUrl = url; })
        .catch(() => {});
    };

    const start = async (button) => {
      if (!button || button.disabled) return;

      audio.pause();
      mark(playing, false);
      playing = button;
      cursor = buttons.indexOf(button);
      paint();

      // Двете беди се различават: НЯМА ОТКЪС (Deezer го каза) — копчето
      // угасва завинаги, не лъже. ОТКАЗАНО ПУСКАНЕ (политика за автопускане,
      // прекъсване) — нищо не се гаси: следващото натискане може да мине.
      let url = button.dataset.gmUrl;
      if (!url) {
        try {
          url = await preview(button.dataset.gmPlay);
          button.dataset.gmUrl = url;
        } catch (error) {
          if (playing === button) { playing = null; paint(); }
          button.disabled = true;
          return;
        }
      }
      if (playing !== button) return;
      try {
        audio.src = url;
        await audio.play();
        mark(button, true);
        paint();
        bar && bar.dispatchEvent(new CustomEvent('gm:perch'));
        const i = buttons.indexOf(button);
        warm(buttons[i + 1]);
        warm(buttons[i - 1]);
      } catch (error) {
        if (playing === button) { playing = null; paint(); }
        mark(button, false);
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (playing === button) { halt(); return; }
        start(button);
      });
    });

    if (bar) {
      // Първото парче се затопля, щом страницата утихне — за да е готово
      // първото натискане, не второто.
      const soon = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200));
      soon(() => warm(buttons[0]));

      // Първото изписване: кое ще тръгне, ако човек натисне сега.
      paint();

      // ЛЕПКАВ, ДОКАТО СВИРИ (Кирил, 28.09). Слезеш ли в дългия трак лист,
      // плеърът е горе под обложката и извън кадъра — по средата на плочата
      // нямаш с какво да спреш звука. Затова, щом обложката мине нагоре под
      // шапката И нещо свири, лентата се закача под шапката; върне ли се
      // обложката, лентата си ляга на мястото.
      //
      // Само докато свири: иначе една лента би висяла над всяка страница без
      // причина.
      const cover = document.querySelector('.gm-cover');
      const hold = bar.parentElement;

      const perch = () => {
        if (!cover) return;
        const shade = gmShadeTop();
        const on = playing !== null && cover.getBoundingClientRect().bottom <= shade;
        if (on === (bar.dataset.gmStuck === 'true')) return;

        bar.dataset.gmStuck = on ? 'true' : 'false';
        // Мястото ѝ не бива да се схлупи под нея: на телефон колоната е висока
        // колкото съдържанието си и страницата би подскочила с нейната височина.
        if (on) {
          bar.style.setProperty('--gm-shade', shade + 'px');
          hold.style.paddingBottom = bar.getBoundingClientRect().height + 'px';
        } else {
          hold.style.paddingBottom = '';
        }
        bar.classList.toggle('is-stuck', on);
      };

      // Horizon заключва документа (`html { overflow: hidden }`) и скролва
      // `.page-wrapper` — на тази страница събитието НЕ стига до прозореца.
      // Затова се слуша и на двете места; излишният слушател е по-евтин от
      // мълчащ плеър. (Урокът вече е хващан веднъж, при авто-свиването.)
      addEventListener('scroll', perch, { passive: true });
      document.querySelector('.page-wrapper')?.addEventListener('scroll', perch, { passive: true });
      addEventListener('resize', perch, { passive: true });
      bar.addEventListener('gm:perch', perch);

      // Парче, което Deezer е отказал, е `disabled` — прескача се, вместо да
      // спре хода. Краищата не се въртят в кръг: «назад» от първото и «напред»
      // от последното не правят нищо, което е по-честно от скок в другия край.
      const reach = (from, dir) => {
        let i = from;
        while (i >= 0 && i < buttons.length && buttons[i].disabled) i += dir;
        return i >= 0 && i < buttons.length ? i : -1;
      };

      bar.addEventListener('click', (event) => {
        const go = event.target.closest('[data-gm-preview-go]');
        if (!go) return;

        if (go.dataset.gmPreviewGo === 'play') {
          if (playing) { halt(); return; }
          const i = reach(cursor, 1);
          start(buttons[i > -1 ? i : reach(0, 1)]);
          return;
        }

        const dir = go.dataset.gmPreviewGo === 'next' ? 1 : -1;
        const i = reach((playing ? buttons.indexOf(playing) : cursor) + dir, dir);
        if (i > -1) start(buttons[i]);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
